/** Default production shortcut — sama dengan Spotlight SSO legacy (Ctrl+Shift+F). */
export const DEFAULT_SPOTLIGHT_SHORTCUT = 'mod+shift+f';
export const SEARCH_DEBOUNCE_MS = 500;
export const HISTORY_LIMIT = 5;
export const RECOMMENDATION_LIMIT = 3;
/** Status my-app yang berarti user punya akses (assigned via role_menu_access). */
export const MY_APP_STATUS_PUBLISHED = 'published';
